import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, Typography, Grid } from '@mui/material';
import { styles } from './styles';

function CoachingBenefitsStep({
  title,
  subtitle,
  description,
  picture,
  extraPicture,
  index,
}) {
  const isLeftImgPosition = index % 2;

  return (
    <Box
      sx={{
        backgroundColor: 'kit.background.lightpurple',
        pl: 8,
        ':first-of-type': {
          pt: 3,
          borderTopLeftRadius: 64,
          borderTopRightRadius: 64,
        },
        ':last-child ': {
          borderBottomLeftRadius: 64,
          borderBottomRightRadius: 64,
        },
      }}
    >
      <Grid
        container
        columnSpacing={8}
        direction={isLeftImgPosition ? 'row' : 'row-reverse'}
      >
        <Grid item xs={6} container>
          <Grid item xs={10} alignSelf="flex-end">
            {title && (
              <Typography variant="desktopH5" color="kit.text.secondary">
                {`<${title}>`}
              </Typography>
            )}

            <Typography variant="desktopH2" color="kit.text.main">
              {subtitle}
            </Typography>
          </Grid>
          <Grid item xs={10} mt={2}>
            <Typography
              component={'div'}
              color="kit.text.secondary"
              variant="desktopP2"
              fontSize={16}
            >
              {Array.isArray(description)
                ? description.map((item) => (
                    <Typography key={item}>{item}</Typography>
                  ))
                : description}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={6} alignSelf="flex-start" sx={{ position: 'relative' }}>
          {extraPicture && (
            <Box sx={styles.rotatingPicture}>
              <GatsbyImage
                image={getImage(extraPicture)}
                alt={`roller-${index}`}
                loading="lazy"
              />
            </Box>
          )}
          <Box sx={styles.image}>
            <GatsbyImage
              image={getImage(picture)}
              alt={`you_will_get-${index}`}
              loading="lazy"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CoachingBenefitsStep;
